import LocalStorage from '../../data/local-storage';
import CONFIG from '../../config/app-config';
import { calculateDistance } from '../../utils/helpers';

export default class BookmarksModel {
  constructor() {
    this.bookmarks = [];
    this.isAuthenticated = false;
    this.user = {};
    this.currentUserLocation = null;
  }

  loadUserState() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    
    if (token && userData) {
      this.isAuthenticated = true;
      this.user = JSON.parse(userData);
      
      const bookmarksKey = `heliaedu_user_bookmarks_${this.user.id}`;
      this.bookmarks = LocalStorage.getObject(bookmarksKey) || [];
      
      const locationKey = `heliaedu_user_location_${this.user.id}`;
      this.currentUserLocation = LocalStorage.getObject(locationKey);
    } else {
      this.isAuthenticated = false;
      this.user = {};
      this.bookmarks = [];
    }
  }

  getBookmarks() {
    return this.bookmarks;
  }

  removeBookmark(storyId) {
    const oldLength = this.bookmarks.length;
    this.bookmarks = this.bookmarks.filter(b => b.storyId !== storyId);
    
    if (this.bookmarks.length < oldLength) {
      const bookmarksKey = `heliaedu_user_bookmarks_${this.user.id}`;
      LocalStorage.setObject(bookmarksKey, this.bookmarks);
      return true;
    }
    return false;
  }

  clearAllBookmarks() {
    this.bookmarks = [];
    const bookmarksKey = `heliaedu_user_bookmarks_${this.user.id}`;
    LocalStorage.setObject(bookmarksKey, []);
    return true;
  }

  getBookmarkCount() {
    return this.bookmarks.length;
  }

  getBookmarksWithDistance() {
    if (!this.currentUserLocation) {
      return this.bookmarks.map(bookmark => ({
        ...bookmark,
        distance: null
      }));
    }

    return this.bookmarks.map(bookmark => {
      let distance = null;
      if (bookmark.lat && bookmark.lon && this.currentUserLocation) {
        distance = calculateDistance(
          this.currentUserLocation.lat,
          this.currentUserLocation.lon,
          bookmark.lat,
          bookmark.lon
        );
      }
      return {
        ...bookmark,
        distance
      };
    });
  }

  async getLocationName(lat, lon) {
    try {
      const response = await fetch(
        `https://api.maptiler.com/geocoding/${lon},${lat}.json?key=${CONFIG.MAP_TILER_KEY}`
      );
      const data = await response.json();
      
      if (data.features && data.features.length > 0) {
        const placeName = data.features[0].place_name;
        const parts = placeName.split(',');
        
        if (parts.length >= 2) {
          return `${parts[0].trim()}, ${parts[1].trim()}`;
        }
        return parts[0].trim();
      }
    } catch (error) {
      
    }

    return `${lat.toFixed(3)}, ${lon.toFixed(3)}`;
  }

  getSortedBookmarks() {
    return [...this.bookmarks].sort((a, b) => 
      new Date(b.savedAt) - new Date(a.savedAt)
    );
  }

  getBookmarkStats() {
    const totalBookmarks = this.bookmarks.length;
    const withLocation = this.bookmarks.filter(b => b.lat && b.lon).length;
    const withImages = this.bookmarks.filter(b => b.photoUrl).length;

    return {
      total: totalBookmarks,
      withLocation,
      withImages
    };
  }

  setBookmarks(bookmarks) {
    this.bookmarks = bookmarks;
  }

  updateGlobalBookmarks(newBookmarks) {
    this.bookmarks = newBookmarks;
  }
}